module.exports = __webpack_public_path__ + "treeline-illustration-3d3GuhM.svg";